import { CONST } from '../../consts/consts';
import { EventRegister } from '../tools/EventRegister';
import history from '../tools/history';
import domains from '../../res/domains/domains.json';
import { isWebview, getDomainURI } from '../tools/uri';
import store from "../../store/store";
import moment from 'moment-jalaali'
import * as actions from "../../actions";
import Cookies from 'universal-cookie';

let CryptoJS = require("crypto-js");
const cookies = new Cookies();

class REST_API {




    constructor() {

        let domain = getDomainURI();
        if (window.location.host !== 'test.bimic.ir'){
            this.domain = domains["API"]["bimic"];
        }
        if (domain === 'localhost:3000') {
            this.domain = domains["API"]["localhost"];
        } else if (domain === 'sodoor724.ir') {
            this.domain = "https://sodoor724.ir/newapi/"
        } else if (window.location.host === 'test.bimic.ir') {
            this.domain = "https://panel.sodoor724.ir/newapi/"
        }

        this.setHeader();
    }


    _recercive(object)
    {

        let n_object = '';
        let keys = Object.keys(object);

        keys.forEach((item, index) => {
            if (typeof object[item] === 'object' && object[item] !== null) {
                if (object[item].length === undefined) { // {}
                    n_object += item + ':' + JSON.stringify(object[item])
                } else { // [1,2,3] or [{}, {}, {}]
                    n_object += item + ':' + JSON.stringify(object[item]) + ';؛'
                }

            } else {
                n_object += item + ':' + (object[item] ? object[item] : null) + ';؛'
            }

        })

        return n_object;
    }

    _makeRequest(object) {


        let time = moment().add(120, 'seconds').unix()
        let random = Math.random()
        let n_object =  'time:' + time + ';؛' + 'random:' + random + ';؛';

        n_object += this._recercive(object)


        let key = CryptoJS.enc.Hex.parse(CONST["k"]);
        let iv = CryptoJS.enc.Hex.parse(CONST["i"]);

        let encrypted = CryptoJS.AES.encrypt(n_object, key, {
            iv,
            padding: CryptoJS.pad.ZeroPadding,
        });


        return encrypted.toString();
    }

    logAPI(response) {
        if(CONST.LOG) {
        }
    }

    async setHeader(type = 'isJson') {

        this.app_header = {
            'Accept': 'application/json',
            'Content-Type': (type === 'isFormData')?'multipart/form-data':'application/json;charset=utf-8',


    }
        let member = cookies.get('member');
        if(member && member !== '' && !isWebview()){
            this.app_header.token = (member).token;
        }
    }


    formBodyCreator(obj) {
        var formBody = [];
        for (var property in obj) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(obj[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        return formBody.join("&");
    }

    formDataCreator(obj) {
        let formData = new FormData();
        for (var property in obj) {
            formData.append(property, obj[property]);
        }
        return formData;
    }

    async afterRecieveResponse(response) {

        // --- LOG ---
        this.logAPI(response);
        // --- END ---
        if(response.status === 401) {
            cookies.remove('member')
            history.replace('/');
            store.dispatch(actions.logout())
        } else if (response.status === 404) {
            // let split = window.location.hostname.split('.');
            alert('۴۰۴')
            // window.location.assign('http://' + split[1] + ' . ' + split[2])
        }

        return response.json();

    }

    async post(url, obj={} , hash = true) {
        console.log(obj)
        await this.setHeader();
        return fetch(this.domain + url, {
            method: 'POST',
            headers: this.app_header,
            body:hash === true ? JSON.stringify({'r' : this._makeRequest(obj)}) : JSON.stringify(obj),
            withCredentials: true
        })
            .then((response) =>  this.afterRecieveResponse(response) )
            .catch((error) => {
                EventRegister.emit('notification.open', 'خطا در برقراری ارتباط با سرور')
            });
    }

    async getExternal(url, obj={}) {
        await this.setHeader();
        return fetch(url, {
            method: 'GET',
            withCredentials: true
        })
            .then((response) =>  response.json())
            .catch((error) => {
                EventRegister.emit('notification.open', 'خطا در برقراری ارتباط با سرور')
            });
    }


    async get(url) {
        await this.setHeader();
        return fetch(this.domain + url, {
            method: 'GET',
            headers: this.app_header,
            withCredentials: true
        })
            .then((response) =>  this.afterRecieveResponse(response) )
            .catch((error) => {
                EventRegister.emit('notification.open', 'خطا در برقراری ارتباط با سرور');
            });
    }


}


export default REST_API;
